/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S2_P1Inputs */

const en_guide_what_is_json_s2_p1 = /** @type {(inputs: Guide_What_Is_Json_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON supports six data types that cover most data representation needs. Understanding these types is essential for working with JSON effectively.`)
};

const ko_guide_what_is_json_s2_p1 = /** @type {(inputs: Guide_What_Is_Json_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON은 대부분의 데이터 표현 요구를 충족하는 여섯 가지 데이터 타입을 지원합니다. 이 타입들을 이해하는 것은 JSON을 효과적으로 다루는 데 필수적입니다.`)
};

const ja_guide_what_is_json_s2_p1 = /** @type {(inputs: Guide_What_Is_Json_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONは、ほとんどのデータ表現ニーズをカバーする6つのデータ型をサポートしています。これらの型を理解することは、JSONを効果的に扱うために不可欠です。`)
};

/**
* | output |
* | --- |
* | "JSON supports six data types that cover most data representation needs. Understanding these types is essential for working with JSON effectively." |
*
* @param {Guide_What_Is_Json_S2_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s2_p1 = /** @type {((inputs?: Guide_What_Is_Json_S2_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S2_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s2_p1(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s2_p1(inputs)
	return ja_guide_what_is_json_s2_p1(inputs)
});